import { ReactNode } from '@tanstack/react-router';
import { SettlementRuleMappingAssignmentStatusEnumEnum } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { Tag, TagVariant } from '@optimus-web/core';

interface Props {
    status?: SettlementRuleMappingAssignmentStatusEnumEnum;
}

const statusConfig: Record<SettlementRuleMappingAssignmentStatusEnumEnum, { variant: TagVariant; label: ReactNode }> = {
    [SettlementRuleMappingAssignmentStatusEnumEnum.Assigned]: {
        variant: 'success',
        label: lt('PaymentPolicyAssignedStatus'),
    },
    [SettlementRuleMappingAssignmentStatusEnumEnum.Unassigned]: {
        variant: 'info',
        label: lt('PaymentPolicyUnassignedStatus'),
    },
};

export const PaymentPolicyStatus = ({ status = SettlementRuleMappingAssignmentStatusEnumEnum.Unassigned }: Props) => {
    const { variant, label } = statusConfig[status];
    return (
        <Tag variant={variant} outline>
            {label}
        </Tag>
    );
};
